import { IServiceOpcode } from '@signal/asp-data-commons';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OnInit, OnDestroy, Component, Inject } from '@angular/core';

@Component({
    selector: 'app-other-service-opcode',
    templateUrl: './other-service-opcode.component.html',
    styleUrls: ['../../../shared/components/confirm-dialog/confirm-dialog.component.scss', './other-service-opcode.component.scss']
})
export class OtherServiceOpcodeComponent implements OnInit, OnDestroy {
    defaultDescription: string = 'Not finding what you are looking for, please add the reason for your service';
    errorText: string = '';
    form: UntypedFormGroup;
    otherServiceDetails: IServiceOpcode;
    constructor(
        private readonly formBuilder: UntypedFormBuilder,
        public readonly dialogRef: MatDialogRef<OtherServiceOpcodeComponent>,
        @Inject(MAT_DIALOG_DATA) public readonly data: any
    ) { }

    ngOnInit() {

        this.form = this.formBuilder.group({
            opcode: [this.otherServiceDetails?.opcode || '', [Validators.required]],
            description: [this.otherServiceDetails?.description || this.defaultDescription, [Validators.required]]
        });
    }

    saveOtherServiceOpcode() {
        this.dialogRef.close({ action: 'close' });
    }

    close() {
        this.dialogRef.close({ action: 'close' });
    }

    ngOnDestroy() {

    }
}
